/**
 * idCadUtils — helpers for parsing and resolving information from product id_cad.
 *
 * Canonical example: "0A-01-03-M-032"
 * - segment[0] => building id_cad ("0A")
 * - segment[2] => entrance ref_tier ("03" -> 3)
 */

function normalizeIdCad(idCad) {
  const value = String(idCad ?? '').trim()
  return value.length > 0 ? value : null
}

export function splitIdCad(idCad) {
  const normalized = normalizeIdCad(idCad)
  if (!normalized) return []
  return normalized.split('-')
}

export function getBuildingIdCadFromIdCad(idCad) {
  const parts = splitIdCad(idCad)
  return parts[0] ?? null
}

export function getEntranceRefTierFromIdCad(idCad) {
  const parts = splitIdCad(idCad)
  if (parts.length < 3) return null

  const parsed = Number(parts[2])
  return Number.isFinite(parsed) ? parsed : null
}

export function findBuildingByIdCad(buildingIdCad, buildingsData) {
  const normalized = normalizeIdCad(buildingIdCad)
  if (!normalized || !Array.isArray(buildingsData)) return null

  return buildingsData.find((item) => item?.id_cad === normalized) ?? null
}

export function getBuildingNameByIdCad(buildingIdCad, buildingsData) {
  return findBuildingByIdCad(buildingIdCad, buildingsData)?.name_original ?? null
}

export function findBuildingByProductIdCad(productIdCad, buildingsData) {
  const buildingIdCad = getBuildingIdCadFromIdCad(productIdCad)
  return findBuildingByIdCad(buildingIdCad, buildingsData)
}

export function getBuildingNameByProductIdCad(productIdCad, buildingsData) {
  return findBuildingByProductIdCad(productIdCad, buildingsData)?.name_original ?? null
}

export function findTierByRefTier(refTier, tiersData, buildingIdCad = null) {
  const numericRefTier = Number(refTier)
  if (!Number.isFinite(numericRefTier) || !Array.isArray(tiersData)) return null

  if (buildingIdCad) {
    return (
      tiersData.find(
        (tier) => Number(tier?.ref_tier) === numericRefTier && String(tier?.building_id ?? '') === String(buildingIdCad),
      ) ?? null
    )
  }

  return tiersData.find((tier) => Number(tier?.ref_tier) === numericRefTier) ?? null
}

export function findEntranceTierInProduct(product) {
  const entranceRefTier = getEntranceRefTierFromIdCad(product?.id_cad)
  if (!Number.isFinite(entranceRefTier)) return null

  const tiers = Array.isArray(product?.tiers) ? product.tiers : []
  return tiers.find((tier) => Number(tier?.ref_tier) === entranceRefTier) ?? null
}

export function getEntranceTierNameFromProduct(product) {
  return findEntranceTierInProduct(product)?.name_original ?? null
}
